
// export default DateForm;
import React, { useEffect, useState } from "react";
import DatePicker, { Calendar } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { AnimatePresence, motion } from "framer-motion";
import Button from "../UI/Button";
import Input, { RadioButtonGroup } from "../UI/Input";
import SecondaryButton from "../UI/SecondaryButton";
import moment from "moment";
import { useSelector } from "react-redux";
import { DatesModal } from "../UI/Modal";
import { FaCheck } from "react-icons/fa6";
import BasicTimePicker from "../components/MobileTime";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import SecondaryOutline from "../UI/SecondaryOutline";
import { IoCloseOutline } from "react-icons/io5";
import { useMediaQuery } from "react-responsive";
import { set } from "react-hook-form";

export default function DateForm({ onSubmit, formData, setFormData }) {
  const storedFormData = useSelector((state) => state.formData);
  console.log(storedFormData, formData);
  const [dates, setDates] = useState(formData?.batches || []);
  const [repeat, setRepeat] = useState(false);
  const [newDate, setNewDate] = useState({
    startdate: "",
    starttime: "",
    enddate: "",
    endtime: "",
  });
  const [datesVisible, setDatesVisible] = useState(false);
  const [selectedFrequency, setSelectedFrequency] = useState(null);
  const [filter, setFilter] = useState("all");
  const repeatOptions = [
    { value: "all", label: "All" },
    { value: "weekday", label: "Weekdays" },
    { value: "weekend", label: "Weekend" },
  ];
  const [isHourlyEvent, setIsHourlyEvent] = useState(false);
  const [days, setDays] = useState(storedFormData.number_of_days);
  const [nights, setNights] = useState(storedFormData.number_of_nights);
  const [hours, setHours] = useState(storedFormData.number_of_hours);
  const [dateOptionSelected, setDateOptionSelected] = useState(
    storedFormData.repeats ? "repeat" : "custom"
  );
  const [tillDate, setTillDate] = useState(null);
  const dateOptions = [
    { value: "custom", label: "Custom dates" },
    { value: "repeat", label: "Repeat" },
  ];
  const [repeatDate, setRepeatDate] = useState({
    startdate: formData?.repeatedDate?.startdate || "",
    starttime: formData?.repeatedDate?.starttime || "",
    enddate: formData?.repeatedDate?.enddate || "",
    endtime: formData?.repeatedDate?.endtime || "",
  });

  console.log("REPEAT DATE", repeatDate);

  useEffect(() => {
    if (formData?.batches) {
      setDates(formData.batches);
    }
  }, [formData.batches]);
  const timeOptions = [
    { value: "multiday", label: "Multi-day" },
    { value: "hourly", label: "Hourly" },
  ];

  const days_of_week = [
    { name: "Mon", type: "weekday" },
    { name: "Tues", type: "weekday" },
    { name: "Wed", type: "weekday" },
    { name: "Thur", type: "weekday" },
    { name: "Fri", type: "weekday" },
    { name: "Sat", type: "weekend" },
    { name: "Sun", type: "weekend" },
  ];

  useEffect(() => {
    const reps = dateOptionSelected == "repeat" ? true : false;
    setFormData((prevData) => {
      return {
        ...prevData,
        repeats: reps,
      };
    });
  }, [dateOptionSelected]);

  useEffect(() => {
    setFormData((prevData) => {
      return {
        ...prevData,
        number_of_days: days,
        number_of_nights: nights,
        number_of_hours: hours,
      };
    });
  }, [days, nights, hours]);

  const toggleDays = (filter) => {
    setFilter(filter);
    if (filter === "all") {
      setSelectedDays(days_of_week.map((day) => day.name));
    } else {
      setSelectedDays(
        days_of_week.filter((day) => day.type === filter).map((day) => day.name)
      );
    }
  };
  const [selectedDays, setSelectedDays] = useState(
    days_of_week.map((day) => day.name)
  );
  const toggleDay = (dayName) => {
    setSelectedDays((prev) =>
      prev.includes(dayName)
        ? prev.filter((day) => day !== dayName)
        : [...prev, dayName]
    );
  };

  const isEdit = useSelector((state) => state.isEdit);

  useEffect(() => {
    console.log('daes',dates)
  },[dates])

  const handleSelectChange = (e) => {
    console.log(e.target.value);
    setSelectedFrequency(e.target.value);
    setFormData((prevData) => {
      return {
        ...prevData,
        repeatType: e.target.value,
      };
    });
    console.log(e.target.value);
  };

  const addDate = () => {
    // if (
    //   newDate.startdate &&
    //   newDate.starttime &&
    //   newDate.enddate &&
    //   newDate.endtime
    // ) {
    // }
    setNewDate({
      startdate: "",
      starttime: "",
      enddate: "",
      endtime: "",
    });
    setDates((prevDates) => [...prevDates, { ...newDate }]);
    setRepeat(false);
  };

  useEffect(() => {
    console.log("DATES", dates);
    setFormData((prevData) => {
      return {
        ...prevData,
        dates: dates,
      };
    });
  }, [dates]);

  useEffect(() => {
    setFormData((prevData) => {
      return {
        ...prevData,
        repeatedDate: repeatDate,
      };
    });
  }, [repeatDate]);

  const handleSubmit = () => {
    onSubmit(dates);
  };

  const closeModal = () => {
    setDatesVisible(false);
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 0 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{ opacity: { duration: 0.75 }, y: { duration: 0.5 } }}
      >
        <div className=" px-6 py-4 pt-0 min-h-[80vh] pb-20">
          {/* <div className="py-4 mt-4 lg:mt-0 lg:section_padding_lg align-baseline grid grid-rows-1 lg:grid-cols-3">
            <h2 className="section_heading mb-2 lg:mb-0">Duration*</h2>
            <div className="flex flex-col w-full col-span-2">
              <div className="pb-3">
                <RadioButtonGroup
                  columns={2}
                  options={timeOptions}
                  selectedValue={isHourlyEvent ? "hourly" : "multiday"}
                  onChange={(value) => {
                    value == "hourly"
                      ? setIsHourlyEvent(true)
                      : setIsHourlyEvent(false);
                  }}
                />
              </div>
              <div className="flex flex-col lg:flex-row w-full gap-2 pt-2">
                <div className={`basis-full ${isHourlyEvent ? "hidden" : ""}`}>
                  <label className="text-sm input_label_padding  font-medium">
                    Day(s)
                  </label>
                  <Input
                    placeholder="Day(s)"
                    type="number"
                    handleChange={(e) => {
                      setDays(e.target.value);
                    }}
                    value={days}
                    classes={"w-full"}
                  />
                </div>
                <div className={`basis-full ${isHourlyEvent ? "hidden" : ""}`}>
                  <label className="text-sm input_label_padding  font-medium">
                    Night(s)
                  </label>
                  <Input
                    placeholder="Night(s)"
                    type="number"
                    handleChange={(e) => {
                      setNights(e.target.value);
                    }}
                    value={nights}
                    classes={"w-full"}
                  />
                </div>

                <div
                  className={`${
                    isHourlyEvent ? "lg:w-[50%] col-span-1" : "basis-full "
                  }`}
                >
                  <label className="text-sm input_label_padding  font-medium">
                    Hour(s)
                  </label>
                  <Input
                    placeholder="Hour(s)"
                    type="number"
                    handleChange={(e) => {
                      setHours(e.target.value);
                    }}
                    value={hours}
                    classes={"w-full"}
                    required={isHourlyEvent}
                  />
                </div>
              </div>
            </div>
          </div> */}

          <div className="section_padding_sm grid lg:grid-cols-3 lg:section_padding_lg">
            <h2 className="section_heading">Open dates</h2>
            <div className="flex flex-col gap-0 col-span-2">
              {isEdit == false && (
                <div class=" mb-3">
                  <RadioButtonGroup
                    columns={2}
                    options={dateOptions}
                    selectedValue={dateOptionSelected}
                    onChange={(value) => {
                      setDateOptionSelected(value);
                    }}
                    name="dateOptions"
                  />
                </div>
              )}

              {dateOptionSelected == "custom" && (
                <div className="flex flex-col gap-0">
                  <div className="">
                    {(isEdit ? [...dates].slice(0, 1) : [...dates]).map(
                      (date, index) => (
                        <div className="pt-3">
                          <div className="grid relative grid-cols-2 text-left grid-rows-2 place-items-start border border-[#dad3c3] px-[19.5px] py-[14px] rounded-xl border-dashed lg:grid-cols-2 lg:grid-rows-1 gap-y-2 gap-x-2 lg:gap-x-2">
                            <div className="">
                              <label
                                htmlFor="opendate"
                                class="block text-sm input_label_padding font-medium text-gray-900"
                              >
                                Start date
                              </label>

                              <DatePicker
                                format="MMM DD, YYYY"
                                render={
                                  <InputIcon
                                    placeholder={"Select date"}
                                    className="lg:w-[180px] w-[100%] focus-within:border-[#B5B0A1] focus:outline-none text-[13px] border px-[13px] py-[9.570px] rounded-xl"
                                  />
                                }
                                placeholder="Select date"
                                
                                value={new Date(date.startdate)}
                                // value={startDateValue}
                                onChange={(value) => {
                                  console.log("value",  value.format("YYYY-MM-DD"))
                                  setDates((prevDates) => {
                                    const updatedDates = [...prevDates];
                                    const formattedStartDate =
                                      value.format("YYYY-MM-DD");
                                    if (date.id) {
                                      // Find the object by ID and update it immutably
                                      return updatedDates.map((d) =>
                                        d.id === date.id
                                          ? {
                                              ...d,
                                              startdate:
                                                value.format(
                                                  "YYYY-MM-DD"
                                                ),
                                              enddate: days
                                                ? moment(formattedStartDate)
                                                    .add(days - 1, "days")
                                                    .format("YYYY-MM-DD")
                                                : d.enddate, // If duration exists, update end date
                                            }
                                          : d
                                      );
                                    } else {
                                      // Update by index (immutable way)
                                      updatedDates[index] = {
                                        ...date,
                                        startdate:
                                          value.format("YYYY-MM-DD"),
                                      };
                                      return updatedDates;
                                    }
                                  });
                                }}
                                id="opendate"
                              />
                            </div>
                            <div className="">
                              <label
                                htmlFor="opendate"
                                class="block text-sm input_label_padding font-medium text-gray-900"
                              >
                                End date
                              </label>
                              <DatePicker
                                format="MMM DD, YYYY"
                                render={
                                  <InputIcon
                                    placeholder={"Select date"}
                                    className="lg:w-[180px] w-[100%] focus-within:border-[#B5B0A1] focus:outline-none text-[13px] border px-[13px] py-[9.570px] rounded-xl"
                                  />
                                }
                                placeholder="Select date"
                                // value={endDateValue}
                                value={new Date(date.enddate)}
                                onChange={(value) => {
                                  setDates((prevDates) => {
                                    const updatedDates = [...prevDates];

                                    if (date.id) {
                                      // Find the object by ID and update it immutably
                                      return updatedDates.map((d) =>
                                        d.id === date.id
                                          ? {
                                              ...d,
                                              enddate:
                                                value.format(
                                                  "YYYY-MM-DD"
                                                ),
                                            }
                                          : d
                                      );
                                    } else {
                                      // Update by index (immutable way)
                                      updatedDates[index] = {
                                        ...date,
                                        enddate:
                                          value.format("YYYY-MM-DD"),
                                      };
                                      return updatedDates;
                                    }
                                  });
                                }}
                                id="closedate"
                              />
                            </div>
                            <div class="flex flex-col">
                              <label
                                for="start-time"
                                class="text-sm input_label_padding font-medium text-gray-700"
                              >
                                Start time
                              </label>

                              <BasicTimePicker
                                label="starttime"
                                // value={startValue}
                                value={moment(date.starttime, "hh:mm").toDate()}
                                handleChange={(value) => {
                                  setDates((prevDates) => {
                                    const updatedDates = [...prevDates];

                                    if (date.id) {
                                      // Find the object by ID and update it immutably
                                      return updatedDates.map((d) =>
                                        d.id === date.id
                                          ? { ...d, starttime: value }
                                          : d
                                      );
                                    } else {
                                      // Update by index (immutable way)
                                      updatedDates[index] = {
                                        ...date,
                                        starttime: value,
                                      };
                                      return updatedDates;
                                    }
                                  });
                                }}
                                // width={isMobile && '160px'}
                                // width={'160px'}
                              />
                            </div>
                            <div class="flex flex-col">
                              <label
                                for="end-time"
                                class="text-sm input_label_padding font-medium text-gray-700"
                              >
                                End time
                              </label>

                              <BasicTimePicker
                                label="endtime"
                                // value={endValue}
                                value={moment(date.endtime, "hh:mm").toDate()}
                                handleChange={(value) => {
                                  setDates((prevDates) => {
                                    const updatedDates = [...prevDates];

                                    if (date.id) {
                                      // Find the object by ID and update it immutably
                                      return updatedDates.map((d) =>
                                        d.id === date.id
                                          ? { ...d, endtime: value }
                                          : d
                                      );
                                    } else {
                                      // Update by index (immutable way)
                                      updatedDates[index] = {
                                        ...date,
                                        endtime: value,
                                      };
                                      return updatedDates;
                                    }
                                  });
                                }}
                                // width={isMobile && '160px'}
                                // width={'160px'}
                              />
                            </div>
                            {/* {!repeats && (
                <div
                  onClick={() => removeDate(index)}
                  className="absolute cursor-pointer lg:top-4 lg:right-5 top-2 right-2"
                >
                 
                </div>
              )} */}
                          </div>
                        </div>
                      )
                    )}
                    {isEdit &&
                      dates?.length > formData.batches.length &&
                      dates
                        .slice(formData.batches.length, dates.length)
                        .map((date,index) => (
                          <div className="pt-3">
                            <div className="grid relative grid-cols-2 text-left grid-rows-2 place-items-start border border-[#dad3c3] px-[19.5px] py-[14px] rounded-xl border-dashed lg:grid-cols-2 lg:grid-rows-1 gap-y-2 gap-x-2 lg:gap-x-2">
                              <div className="">
                                <label
                                  htmlFor="opendate"
                                  class="block text-sm input_label_padding font-medium text-gray-900"
                                >
                                  Start date
                                </label>

                                <DatePicker
                                  format="MMM DD, YYYY"
                                  render={
                                    <InputIcon
                                      placeholder={"Select date"}
                                      className="lg:w-[180px] w-[100%] focus-within:border-[#B5B0A1] focus:outline-none text-[13px] border px-[13px] py-[9.570px] rounded-xl"
                                    />
                                  }
                                  placeholder="Select date"
                                  
                                  // value={startDateValue}
                                  onChange={(value) => {
                                    setDates((prevDates) => {
                                      const updatedDates = [...prevDates];
                                      const formattedStartDate =
                                        value.format("YYYY-MM-DD");
                                      if (date.id) {
                                        // Find the object by ID and update it immutably
                                        return updatedDates.map((d) =>
                                          d.id === date.id
                                            ? {
                                                ...d,
                                                startdate:
                                                  value.format(
                                                    "YYYY-MM-DD"
                                                  ),
                                                enddate: days
                                                  ? moment(formattedStartDate)
                                                      .add(days - 1, "days")
                                                      .format("YYYY-MM-DD")
                                                  : d.enddate, // If duration exists, update end date
                                              }
                                            : d
                                        );
                                      } else {
                                        // Update by index (immutable way)
                                        updatedDates[index + formData?.batches?.length] = {
                                          ...date,
                                          startdate:
                                            value.format("YYYY-MM-DD"),
                                        };
                                        return updatedDates;
                                      }
                                    });
                                  }}
                                  id="opendate"
                                />
                              </div>
                              <div className="">
                                <label
                                  htmlFor="opendate"
                                  class="block text-sm input_label_padding font-medium text-gray-900"
                                >
                                  End date
                                </label>
                                <DatePicker
                                  format="MMM DD, YYYY"
                                  render={
                                    <InputIcon
                                      placeholder={"Select date"}
                                      className="lg:w-[180px] w-[100%] focus-within:border-[#B5B0A1] focus:outline-none text-[13px] border px-[13px] py-[9.570px] rounded-xl"
                                    />
                                  }
                                  placeholder="Select date"
                                  // value={endDateValue}
                                 
                                  onChange={(value) => {
                                    setDates((prevDates) => {
                                      const updatedDates = [...prevDates];

                                      if (date.id) {
                                        // Find the object by ID and update it immutably
                                        return updatedDates.map((d) =>
                                          d.id === date.id
                                            ? {
                                                ...d,
                                                enddate:
                                                  value.format(
                                                    "YYYY-MM-DD"
                                                  ),
                                              }
                                            : d
                                        );
                                      } else {
                                        // Update by index (immutable way)
                                        updatedDates[index  + formData?.batches?.length] = {
                                          ...date,
                                          enddate:
                                            value.format("YYYY-MM-DD"),
                                        };
                                        return updatedDates;
                                      }
                                    });
                                  }}
                                  id="closedate"
                                />
                              </div>
                              <div class="flex flex-col">
                                <label
                                  for="start-time"
                                  class="text-sm input_label_padding font-medium text-gray-700"
                                >
                                  Start time
                                </label>

                                <BasicTimePicker
                                  label="starttime"
                                  // value={startValue}
                                
                                  handleChange={(value) => {
                                    setDates((prevDates) => {
                                      const updatedDates = [...prevDates];

                                      if (date.id) {
                                        // Find the object by ID and update it immutably
                                        return updatedDates.map((d) =>
                                          d.id === date.id
                                            ? { ...d, starttime: value }
                                            : d
                                        );
                                      } else {
                                        // Update by index (immutable way)
                                        updatedDates[index  + formData?.batches?.length] = {
                                          ...date,
                                          starttime: value,
                                        };
                                        return updatedDates;
                                      }
                                    });
                                  }}
                                  // width={isMobile && '160px'}
                                  // width={'160px'}
                                />
                              </div>
                              <div class="flex flex-col">
                                <label
                                  for="end-time"
                                  class="text-sm input_label_padding font-medium text-gray-700"
                                >
                                  End time
                                </label>

                                <BasicTimePicker
                                  label="endtime"
                                  // value={endValue}
                                  
                                  handleChange={(value) => {
                                    setDates((prevDates) => {
                                      const updatedDates = [...prevDates];

                                      if (date.id) {
                                        // Find the object by ID and update it immutably
                                        return updatedDates.map((d) =>
                                          d.id === date.id
                                            ? { ...d, endtime: value }
                                            : d
                                        );
                                      } else {
                                        // Update by index (immutable way)
                                        updatedDates[index  + formData?.batches?.length] = {
                                          ...date,
                                          endtime: value,
                                        };
                                        return updatedDates;
                                      }
                                    });
                                  }}
                                  // width={isMobile && '160px'}
                                  // width={'160px'}
                                />
                              </div>
                              {/* {!repeats && (
                <div
                  onClick={() => removeDate(index)}
                  className="absolute cursor-pointer lg:top-4 lg:right-5 top-2 right-2"
                >
                 
                </div>
              )} */}
                            </div>
                          </div>
                        ))}

                    <div className="w-full mt-3 text-center">
                      {isEdit && dates?.length > 1 && (
                        <Button
                          handleClick={() => {
                            setDatesVisible(true);
                          }}
                          text="View all dates"
                          classes="mt-0 mb-3 mx-auto"
                        />
                      )}
                    </div>
                    {datesVisible && (
                      <DatesModal
                        closeModal={closeModal}
                        setFormData={setFormData}
                        dates={formData?.dates}
                        // removeDate={removeDate}
                      />
                    )}

                    <SecondaryOutline
                      text={"Add another date"}
                      handleClick={addDate}
                      classes="mt-3 text-left inline-flex w-auto"
                    />
                  </div>
                </div>
              )}
              {dateOptionSelected == "repeat" && (
                <div className="flex flex-col">
                  <div className="grid relative grid-cols-2 text-left grid-rows-2 place-items-start border border-[#dad3c3] px-[19.5px] py-[14px] rounded-xl border-dashed lg:grid-cols-2 lg:grid-rows-1 gap-y-2 gap-x-2 lg:gap-x-2">
                    <div className="">
                      <label
                        htmlFor="opendate"
                        class="block text-sm input_label_padding font-medium text-gray-900"
                      >
                        Start date
                      </label>

                      <DatePicker
                        format="MMM DD, YYYY"
                        render={
                          <InputIcon
                            placeholder={"Select date"}
                            className="lg:w-[180px] w-[100%] focus-within:border-[#B5B0A1] focus:outline-none text-[13px] border px-[13px] py-[9.570px] rounded-xl"
                          />
                        }
                        placeholder="Select date"
                        value={new Date(repeatDate.startdate)}
                        // value={startDateValue}
                        onChange={(value) => {
                          repeatDate.startdate = moment(value.format()).format(
                            "YYYY-MM-DD"
                          );
                          setRepeatDate(repeatDate);
                        }}
                        id="opendate"
                      />
                    </div>
                    <div className="">
                      <label
                        htmlFor="opendate"
                        class="block text-sm input_label_padding font-medium text-gray-900"
                      >
                        End date
                      </label>
                      <DatePicker
                        format="MMM DD, YYYY"
                        render={
                          <InputIcon
                            placeholder={"Select date"}
                            className="lg:w-[180px] w-[100%] focus-within:border-[#B5B0A1] focus:outline-none text-[13px] border px-[13px] py-[9.570px] rounded-xl"
                          />
                        }
                        placeholder="Select date"
                        // value={endDateValue}
                        value={new Date(repeatDate.enddate)}
                        onChange={(value) => {
                          repeatDate.enddate = moment(value.format()).format(
                            "YYYY-MM-DD"
                          );
                          setRepeatDate(repeatDate);
                        }}
                        id="closedate"
                      />
                    </div>
                    <div class="flex flex-col">
                      <label
                        for="start-time"
                        class="text-sm input_label_padding font-medium text-gray-700"
                      >
                        Start time
                      </label>

                      <BasicTimePicker
                        label="starttime"
                        // value={startValue}
                        value={moment(repeatDate.starttime, "hh:mm").toDate()}
                        handleChange={(value) => {
                          repeatDate.starttime = value;
                          setRepeatDate(repeatDate);
                        }}
                        // width={isMobile && '160px'}
                        // width={'160px'}
                      />
                    </div>
                    <div class="flex flex-col">
                      <label
                        for="end-time"
                        class="text-sm input_label_padding font-medium text-gray-700"
                      >
                        End time
                      </label>

                      <BasicTimePicker
                        label="endtime"
                        // value={endValue}
                        value={moment(repeatDate.endtime, "hh:mm").toDate()}
                        handleChange={(value) => {
                          repeatDate.endtime = value;
                          setRepeatDate(repeatDate);
                        }}
                        // width={isMobile && '160px'}
                        // width={'160px'}
                      />
                    </div>
                    {/* {!repeats && (
                <div
                  onClick={() => removeDate(index)}
                  className="absolute cursor-pointer lg:top-4 lg:right-5 top-2 right-2"
                >
                 
                </div>
              )} */}
                  </div>
                  <div className="mt-3 lg:pb-4 grid grid-cols-2 lg:flex gap-2">
                    <div className="flex flex-col gap-1">
                      <label
                        htmlFor="countries"
                        class="block text-sm input_label_padding font-medium text-gray-900"
                      >
                        Repeats
                      </label>
                      <select
                        id="countries"
                        onChange={handleSelectChange}
                        class="border font-medium text-black text-[13px] rounded-xl bg-white focus:outline-none block px-[13px] py-[9.570px]"
                      >
                        <option className="font-medium" defaultChecked>
                          Choose frequency
                        </option>
                        <option value="everyday">Everyday</option>
                        <option value="everyweek">Every week</option>
                      </select>
                    </div>
                    <div className="flex flex-col gap-1">
                      <label
                        htmlFor="tilldate"
                        class="block text-sm input_label_padding font-medium text-gray-900"
                      >
                        Till
                      </label>
                      <DatePicker
                        id="tilldate"
                        format="MMM DD, YYYY"
                        render={
                          <InputIcon
                            placeholder={"Select date"}
                            className="lg:w-[180px] w-[100%] focus-within:border-[#B5B0A1] focus:outline-none text-[13px] border px-[13px] py-[9.570px] rounded-xl"
                          />
                        }
                        placeholder="Select date"
                        value={moment(tillDate).format("MMM DD, YYYY")}
                        onChange={(value) => {
                          console.log(value.format());
                          console.log(
                            moment(value.format()).format("YYYY-MM-DD")
                          );
                          setTillDate(
                            moment(value.format()).format("YYYY-MM-DD")
                          );
                          setFormData((prevData) => {
                            return {
                              ...prevData,
                              tilldate: moment(value.format()).format(
                                "YYYY-MM-DD"
                              ),
                            };
                          });
                        }}
                      />
                    </div>
                  </div>
                  {selectedFrequency == "everyweek" && (
                    <div className="lg:py-4">
                      <div className="my-3 lg:my-0">
                        <RadioButtonGroup
                          columns={3}
                          options={repeatOptions}
                          selectedValue={filter}
                          name="repeatOptions"
                          onChange={(value) => {
                            toggleDays(value);
                          }}
                        />
                      </div>
                      <div className="flex gap-2 flex-wrap py-0 lg:py-4">
                        {days_of_week.map((day) => (
                          <span
                            onClick={() => {
                              toggleDay(day.name);
                            }}
                            className={`w-[54px] h-[24px] items-center ${
                              selectedDays.includes(day.name)
                                ? "bg-[#045540] text-white"
                                : "bg-[#f6f1e9]"
                            } flex justify-center  text-sm rounded-full`}
                          >
                            {day.name}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
